/**
 * Zustand persist strips `password` from localStorage (see funnelV3Store partialize).
 * Keep the post-signup password in sessionStorage + an in-memory fallback so the get-app
 * screen can show copy / mask without long-lived localStorage. The module is imported from
 * the main bundle (via store), so the memory ref survives SPA navigation between lazy chunks.
 */
export const FUNNEL_DISPLAY_PASSWORD_SESSION_KEY = 'mc_funnel_display_password_v1';

let inMemoryFunnelDisplayPassword = '';

export function rememberFunnelAccountPasswordForDisplay(password: string): void {
    if (password) inMemoryFunnelDisplayPassword = password;
    try {
        if (password) sessionStorage.setItem(FUNNEL_DISPLAY_PASSWORD_SESSION_KEY, password);
    } catch {
        /* private mode / quota — in-memory still holds value for this tab */
    }
}

export function readFunnelAccountPasswordForDisplay(): string {
    try {
        const fromSession = sessionStorage.getItem(FUNNEL_DISPLAY_PASSWORD_SESSION_KEY);
        if (fromSession) return fromSession;
    } catch {
        /* ignore */
    }
    return inMemoryFunnelDisplayPassword || '';
}

export function clearFunnelDisplayPasswordSession(): void {
    inMemoryFunnelDisplayPassword = '';
    try {
        sessionStorage.removeItem(FUNNEL_DISPLAY_PASSWORD_SESSION_KEY);
    } catch {
        /* noop */
    }
}
